export const mainDescription = 'LoginModal.Kickout.mainDescription';

export const subDescription = 'LoginModal.Kickout.subDescription';
